import Page from '../../class/Page';

window.pageCurrent = class extends Page {
    init() {
        super.init();

        this.app.gtm.trigger('view_item', appData.page.vars.gtmData);

        this.app.vue.buildSingleComponent(
            document.getElementById('select-location'),
            require('./vue/SelectLocationNoCity.vue')
        );
    }
};
